import { useSyncExternalStore } from 'react'
import { getClient, isPreview } from '../client'

// Every document type the preview hooks read. A change to any of them triggers a refetch.
const LIVE_TYPES = [
  'homePage',
  'newsArticle',
  'informationCard',
  'serviceCardInfo',
  'helpPage',
  'faqItem',
  'translation',
  'translation.metadata',
]
const DEBOUNCE_MS = 300

let version = 0
let subscription: { unsubscribe(): void } | undefined
let timer: ReturnType<typeof setTimeout> | undefined
const listeners = new Set<() => void>()

function bump() {
  clearTimeout(timer)
  timer = setTimeout(() => {
    version++
    for (const listener of listeners) listener()
  }, DEBOUNCE_MS)
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  subscription ??= getClient()
    .listen(
      '*[_type in $types]',
      { types: LIVE_TYPES },
      { events: ['mutation'], includeResult: false, visibility: 'query' },
    )
    .subscribe({ next: bump, error: (err) => console.warn('Sanity live preview disconnected', err) })

  return () => {
    listeners.delete(listener)
    if (listeners.size === 0) {
      subscription?.unsubscribe()
      subscription = undefined
    }
  }
}

const noopSubscribe = () => () => {}
const getVersion = () => version

/**
 * Returns a counter that increases whenever previewed content changes in Sanity.
 * Add it to a fetch effect's dependencies so the Presentation tool shows edits as the editor types.
 * Outside preview mode it never changes and opens no connection.
 */
export function useLiveVersion(): number {
  return useSyncExternalStore(isPreview() ? subscribe : noopSubscribe, getVersion, getVersion)
}
